(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion =
    (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) ||
    (navigator.connection && navigator.connection.saveData) === true;

  function pad2(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function initCinHero(root) {
    if (root.dataset.cinReady) return;
    root.dataset.cinReady = "1";

    var stage = root.querySelector("[data-cin-stage]");
    var layers = Array.prototype.slice.call(root.querySelectorAll("[data-cin-layer]"));
    var captions = Array.prototype.slice.call(root.querySelectorAll("[data-cin-caption]"));
    var hudIndex = root.querySelector("[data-cin-hud-index]");
    var hudLabel = root.querySelector("[data-cin-hud-label]");
    var ticks = Array.prototype.slice.call(root.querySelectorAll("[data-cin-tick]"));
    if (!stage || layers.length < 2) return;
    root.classList.add("cin-hero--js");

    var actief = -1;
    var raf = null;

    function zetFase(f) {
      layers.forEach(function (layer, i) {
        var zicht = Math.max(0, 1 - Math.abs(f - i));
        layer.style.opacity = zicht.toFixed(3);
        layer.style.visibility = zicht > 0.001 ? "visible" : "hidden";
        if (captions[i]) {
          // Tekst steiler dan het beeld: weg vóór de volgende regel komt,
          // met een lichte verticale glijbeweging mee met de scroll.
          var tekstZicht = Math.max(0, 1 - Math.abs(f - i) * 2.2);
          captions[i].style.opacity = tekstZicht.toFixed(3);
          captions[i].style.transform = "translateY(" + ((i - f) * 46).toFixed(1) + "px)";
        }
      });

      var idx = Math.min(layers.length - 1, Math.max(0, Math.round(f)));
      if (idx === actief) return;
      actief = idx;

      if (hudIndex) hudIndex.textContent = pad2(idx + 1) + " / " + pad2(layers.length);
      if (hudLabel) hudLabel.textContent = layers[idx].getAttribute("data-cin-label") || "";
      ticks.forEach(function (tick, i) {
        tick.classList.toggle("is-active", i === idx);
      });
      root.classList.toggle("cin-hero--licht", layers[idx].hasAttribute("data-cin-licht"));
      root.classList.toggle("cin-hero--eind", idx === layers.length - 1);

      layers.forEach(function (layer, i) {
        var video = layer.querySelector("video");
        if (!video) return;
        if (!reduceMotion && Math.abs(i - idx) <= 1) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    function onScroll() {
      if (mobiel.matches) return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var rect = root.getBoundingClientRect();
        var baan = root.offsetHeight - stage.offsetHeight;
        var voortgang = baan > 0 ? Math.min(1, Math.max(0, -rect.top / baan)) : 0;
        zetFase(voortgang * (layers.length - 1));
      });
    }

    // Mobiel: fases spelen vanzelf af als een film; desktop: scroll-gedreven.
    var mobiel = window.matchMedia("(max-width: 760px)");
    var filmTimer = null;
    var filmIdx = 0;

    function stopFilm() {
      if (filmTimer) {
        clearInterval(filmTimer);
        filmTimer = null;
      }
    }

    function startFilm() {
      stopFilm();
      filmIdx = 0;
      zetFase(0);
      filmTimer = setInterval(function () {
        filmIdx++;
        zetFase(filmIdx);
        if (filmIdx >= layers.length - 1) stopFilm();
      }, 5200);
    }

    var laatsteModus = null;

    function zetModus() {
      laatsteModus = mobiel.matches;
      if (mobiel.matches) {
        root.classList.add("cin-hero--auto");
        if (reduceMotion) {
          zetFase(layers.length - 1);
        } else {
          startFilm();
        }
      } else {
        root.classList.remove("cin-hero--auto");
        stopFilm();
        onScroll();
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      if (mobiel.matches !== laatsteModus) {
        zetModus();
      } else {
        onScroll();
      }
    });
    if (mobiel.addEventListener) mobiel.addEventListener("change", zetModus);
    zetModus();
  }

  function initAll() {
    document.querySelectorAll("[data-cin-hero]").forEach(initCinHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector("[data-cin-hero]");
    if (el) initCinHero(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
